module.exports = __webpack_public_path__ + "static/img/3.a67d80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail1/3.png
// module id = qVKT
// module chunks = 19